<template>
  <div class="company-fitness-index-chart">
    <loading-indicator v-if="loading" align-middle/>
    <v-responsive v-if="!loading && fitnessData" :aspect-ratio="1" style="width: 85%; margin: auto;">
      <svg viewBox="0 0 250 250">
        <g transform="translate(125 125)">

          <g transform="rotate(-30)">
            <template v-for="(area) in areas">
              <!--<line v-if="!degrees.includes(area.rotate)"
                    :key="`${area.rotate}_full_line`"
                    :class="[isHoveredArea(area) && 'hovered']"
                    :data-area="area.type"
                    :stroke="area.color"
                    :transform="`rotate( ${area.rotate})`"
                    :x2="isHoveredArea(area) ? 105 : 100"
                    class="full-line"
                    stroke-width="1"
                    style="opacity: 0.3;" x1="50"/>-->
              <path v-if="!degrees.includes(area.rotate)"
                    :key="`${area.rotate}_full_line`"
                    :class="[isHoveredArea(area) && 'hovered']"
                    :d="`M 0,0 L 0,${isHoveredArea(area) ? 105 : 100}`"
                    :data-area="area.type"
                    :stroke="area.color"
                    :transform="`rotate( ${area.rotate - 90})`"
                    :x2="isHoveredArea(area) ? 105 : 100"
                    class="full-line"
                    stroke-width="1" style="opacity: 0.3;"
                    x1="50">
              </path>
              <path :key="`${area.rotate}_score_line`"
                    :class="[isHoveredArea(area) && 'hovered']"
                    :d="`M 0,0 L 0,${isHoveredArea(area) ?(degrees.includes(area.rotate) ? 105 : area.value) + 5 :  (degrees.includes(area.rotate) ? 105 : area.value)}`"
                    :data-area="area.type"
                    :stroke="degrees.includes(area.rotate) ? '#000' : area.color"
                    :stroke-linecap="degrees.includes(area.rotate) ? '' : 'round'"
                    :transform="`rotate(${area.rotate - 90})`"
                    class="score-line"
                    stroke-width="2">
              </path>
              <!--<line :key="`${area.rotate}_score_line`"
                    :class="[isHoveredArea(area) && 'hovered']"
                    :data-area="area.type"
                    :stroke="degrees.includes(area.rotate) ? '#000' : area.color"
                    :stroke-linecap="degrees.includes(area.rotate) ? '' : 'round'"
                    :transform="`rotate( ${area.rotate})`"
                    :x2="/*isHoveredArea(area) ? (degrees.includes(area.rotate) ? 105 : area.value) + 5 :*/ (degrees.includes(area.rotate) ? 105 : area.value)"
                    class="score-line"
                    stroke-width="2" x1="50">
              </line>-->
            </template>
          </g>


          <circle fill="white" r="50" stroke="white"/>
          <!--<text v-if="pointText" :style="`fill: ${$getScoreColorHex(pointValue)} !important`" class="point-header"
                dominant-baseline="middle"
                text-anchor="middle"
                x="0" y="-25">
            {{ pointHeader }}
          </text>-->
          <transition mode="out-in" name="slide-fade">
            <text :key="pointValue" :style="`fill: ${$getScoreColorHex(pointValue)} !important`"
                  dominant-baseline="middle"
                  text-anchor="middle" x="0"
                  y="0">
              {{ pointValue }}
            </text>
          </transition>
          <transition mode="out-in" name="slide-fade">
            <text v-if="pointText" :key="pointText" :style="`fill: ${$getScoreColorHex(pointValue)} !important`"
                  class="point-text"
                  dominant-baseline="middle"
                  text-anchor="middle"
                  x="0" y="20">
              {{ pointText }}
            </text>
          </transition>
          <text :class="[isHoveredArea({type: 'efficiency'}) && 'hovered']"
                class="category-text"
                data-area="efficiency"
                dominant-baseline="middle" style="transform: rotate(300deg)"
                text-anchor="middle"
                x="0" y="115">
            {{ $t('reports.efficiency') }}
          </text>
          <text :class="[isHoveredArea({type: 'capability'}) && 'hovered']"
                class="category-text"
                data-area="capability"
                dominant-baseline="middle" style="transform: rotate(60deg)"
                text-anchor="middle"
                x="0" y="115">
            {{ $t('reports.capability') }}
          </text>
          <text :class="[isHoveredArea({type: 'leadership'}) && 'hovered']"
                class="category-text"
                data-area="leadership"
                dominant-baseline="middle"
                text-anchor="middle"
                x="0" y="-115">
            {{ $t('reports.leadership') }}
          </text>

          <g transform="rotate(-30)">
            <template v-for="(k,i) in fitnessDataKeys">
              <!--<path id="arc1" :d="circleD" :transform="`rotate(${i * 120 + 30})`" fill="red" stroke-width="0"
                    @mouseleave="magicOff()"
                    @mouseover="magic(d)"/>-->
              <path :key="k" :data-part="k" :transform="`rotate(${30 + (i + 1) * 120})`" class="hover-mask" d="
                M 0,0
                L 250,-145
                l 0,-250
                l -500,0
                l 0,252
              " fill="transparent" @click="goTo(k)"
                    @mouseenter="magic(k)"
                    @mouseleave="magicOff()"
              />
            </template>
          </g>
        </g>


      </svg>

      <div class="mt-n4">
        <SWOTLegends justify="center"/>
      </div>
    </v-responsive>
    <v-row v-if="!loading && !fitnessData">
      <v-col cols="12">
        <no-content-view :description="$t('reports.personnel.no_data_help')"
                         :description-extra="$t('reports.personnel.no_data_help2')"
                         :function-button-text="$t('refresh')"
                         :propFunction="() => $emit('refresh')"
                         :reload-button="false" :title="$t('reports.personnel.no_data')"
                         function-button
                         function-button-icon="mdi mdi-refresh"
        ></no-content-view>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import NoContentView from "@/components/NoContentView";
import LoadingIndicator from "@/components/LoadingIndicator";
import SWOTLegends from "@/components/Tenant/Reports/SWOTLegends";

export default {
  name: "CompanyFitnessIndexChart",
  components: {SWOTLegends, LoadingIndicator, NoContentView},
  props: ['calculation', 'loading'],
  data() {
    return {
      selected: null,
    }
  },
  computed: {
    fitnessData() {
      const cfi = this.calculation?.engineResponse?.lta?.cfi;
      if (!cfi) return null;
      return {
        efficiency: {
          value: cfi.efficiency,
        },
        capability: {
          value: cfi.capability,
        },
        leadership: {
          value: cfi.leadership,
        },
        result: {
          value: cfi.result,
        }
      }
    },
    areas() {
      if (!this.fitnessData)
        return null;
      const arrs = [];

      Object.keys(this.fitnessData).forEach((c, index) => {
        if (c === 'result') {
          return;
        }
        const d = {...this.fitnessData[c]};
        d.color = this.$getScoreColorHex(this.fitnessData[c].value);


        for (let i = index * 120; i < ((index + 1) * 120); i += 3) {
          arrs.push({rotate: i, color: d.color, value: 50 / 100 * d.value + 50, type: c});
        }
      })
      return arrs;
    },
    circleD() {
      return this.describeArc(0, 0, 100, -60, 60)
    },
    fitnessDataKeys() {
      return Object.keys(this.fitnessData).filter(c => c !== 'result')
    },
    degrees() {
      return [0, 120, 240];
    },
    pointValue() {
      if (this.selected) {
        return this.fitnessData[this.selected].value > 100 ? parseFloat(Math.round(this.fitnessData[this.selected].value)).toFixed(0) : parseFloat(this.fitnessData[this.selected].value).toFixed(0)
      }
      return this.fitnessData.result.value > 100 ? parseFloat(Math.round(this.fitnessData.result.value)).toFixed(0) : parseFloat(this.fitnessData.result.value).toFixed(0)
    },
    pointText() {
      if (!this.selected) return null;
      return this.pointValue <= 40 ? this.$tc('reports.swot_types.weakness', 1) :
        this.pointValue <= 60 ? this.$tc('reports.swot_types.opportunity', 1) : this.$tc('reports.swot_types.strength', 1)
    },
    pointHeader() {
      if (!this.selected) return null;
      return this.$t('reports.' + this.selected);
    }
  },
  methods: {
    isHoveredArea(area) {
      return area.type === this.selected && !this.degrees.includes(area.rotate)
    },
    polarToCartesian(centerX, centerY, radius, angleInDegrees) {
      var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;

      return {
        x: centerX + (radius * Math.cos(angleInRadians)),
        y: centerY + (radius * Math.sin(angleInRadians))
      };
    },
    describeArc(x, y, radius, startAngle, endAngle) {

      var start = this.polarToCartesian(x, y, radius, endAngle);
      var end = this.polarToCartesian(x, y, radius, startAngle);

      var arcSweep = endAngle - startAngle <= 180 ? "0" : "1";

      var d = [
        "M", start.x, start.y,
        "A", radius, radius, 0, arcSweep, 0, end.x, end.y,
        "L", x, y,
        "L", start.x, start.y
      ].join(" ");

      return d;
    },
    magic(type) {
      this.selected = type;
    },
    magicOff() {
      this.selected = null;
    },
    goTo(type) {
      this.$router.push({name: 'tenant_report_category', params: {category: type}})
    }
  }
}
</script>

<style lang="scss" scoped>
.company-culture-chart {
  width: 100%;
}

svg text {
  font: bold 34px "Jost";
  text-transform: uppercase;
  fill: #000;
}

svg text.point-text {
  font: bold 10px "Jost";
  text-transform: uppercase;
}

svg text.point-header {
  font: bold 12px "Jost";
  text-transform: uppercase;
}

svg .category-text {
  font-size: 10px;
  transition: all 0.2s ease-in-out;
}

svg .score-line, svg .full-line {
  transition: all 0.2s ease-in-out;
}

svg .score-line.hovered {
  stroke-width: 2.7px;
}

svg .category-text.hovered {
  filter: drop-shadow(2px 2px 7px rgb(0 0 0 / 0.2));
  font-size: 10.9px;
}

svg .hover-mask {
  cursor: pointer;
}


@media screen and (max-width: 400px) {
  .company-culture-chart {
    .chart-section-title {
      font-size: 10px !important;
    }
  }
}

.slide-fade-enter-active {
  transition: all .1s ease;
}

.slide-fade-leave-active {
  transition: all .15s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(5px);
  opacity: 0;
}
</style>
